
import { GlobalState } from '@/shared/models/GlobalState';
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import EstateAgentProfileEdit from '@/estate-agent/EstateAgentProfileEdit.vue';
import UserBasicProfileEdit from '@/account/UserBasicProfileEdit.vue';

export default defineComponent({
  name: 'UserProfileEdit',
  components: {
    EstateAgentProfileEdit,
    UserBasicProfileEdit,
  },
  computed: {
    ...mapState({
      user: state => (state as GlobalState).user,
    }),
  },
});
